import React from "react"

import { FormattedMessage } from "react-intl"

const Space = () => <FormattedMessage id={" - "} />

export default Space
